export default class BodyTypeWriteDTO {
    public id: number | undefined;
    public name: string | undefined;
    public label: string | undefined;
    public iconId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.label = data['label'] || undefined;
        this.iconId = data['iconId'] || undefined;
        if (data['icon']) {
            this.iconId = data['icon'].id;
        }
    }
}
